import payment from "./factories/DefaultPaymentGateway";
host.plugins.register({
    // #region Vars
    name: "288a.payment.core",
    // #endregion
    // #region register
    register() {
        host.provider.register('PAYMENT', 'system', new payment());
    }
    // #endregion
});
